import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";

import { useResetPassword } from "#modules/auth/view/useResetPassword";
import { ROUTES } from "#shared/routes";
import { Alert } from "#shared/view/components/Alert";
import { Container } from "#shared/view/components/Container";
import { Form } from "#shared/view/components/Form";
import { Title } from "#shared/view/components/Title";
import { Button } from "#shared/view/designSystem/Button";

export const ResetPasswordPage = () => {
  const [errorMessage, setErrorMessage] = useState("");

  const { token } = useParams();

  const { t } = useTranslation();

  const { resetPassword, isPending: isResetingPassword } = useResetPassword();

  if (!token) {
    return <Navigate to={ROUTES.login} />;
  }

  const handleSubmit = async (data: { password: string; confirmPassword: string }) => {
    if (data.password !== data.confirmPassword) {
      setErrorMessage(t("login.passwordsDoNotMatch"));

      return;
    }
    resetPassword({ token, password: data.password });
  };

  return (
    <Container style={{ marginTop: 40 }}>
      <img
        alt=""
        src="/fabera-logo.png"
        width="70"
        height="70"
        className="d-inline-block align-top"
        style={{ marginBottom: 20 }}
      />
      <Title order={2}>{t("login.forgotPassword")}</Title>
      <Title order={5}>{t("login.chooseNewPassword")}</Title>

      {!!errorMessage && <Alert color="red">{errorMessage}</Alert>}
      <Form
        sections={[
          {
            title: "",
            fields: [
              {
                key: "password",
                label: t("login.newPassword"),
                type: "password",
              },
              {
                key: "confirmPassword",
                label: t("login.confirmPassword"),
                type: "password",
              },
            ],
          },
        ]}
        onSubmit={handleSubmit}
        isLoading={isResetingPassword}
        SubmitComponent={({ isLoading }) => (
          <Button size="lg" type="submit" loading={isLoading}>
            {t("login.validateNewPassword")}
          </Button>
        )}
      />
    </Container>
  );
};
